import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import FormattedBandwidth from './FormattedBandwidth';

function RelayBandwidth(props) {
    return (
      <OverlayTrigger
        overlay={
          <Tooltip>
            Bandwidth rate: <FormattedBandwidth bandwidth={props.bandwidth_rate} /><br />
            Bandwidth burst: <FormattedBandwidth bandwidth={props.bandwidth_burst} /><br />
            Observed bandwidth: <FormattedBandwidth bandwidth={props.observed_bandwidth} />
          </Tooltip>
        }
      >
        <span><FormattedBandwidth bandwidth={props.advertised_bandwidth} /></span>
      </OverlayTrigger>
    );
}

export default RelayBandwidth;
